import { mobileIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Phone = createIcon({
  displayName: 'Phone',
  paths: [
    'M384 853.333v-42.667h256v42.667h-256zM725.333 682.667c0 23.552-19.115 42.667-42.667 42.667h-341.333c-23.552 0-42.667-19.115-42.667-42.667v-426.667c0-23.552 19.115-42.667 42.667-42.667h341.333c23.552 0 42.667 19.115 42.667 42.667v426.667zM725.333 85.333h-426.667c-47.104 0-85.333 38.229-85.333 85.333v682.667c0 47.104 38.229 85.333 85.333 85.333h426.667c47.104 0 85.333-38.229 85.333-85.333v-682.667c0-47.104-38.229-85.333-85.333-85.333z'
  ],
  canvasPaths: canvasIconPaths(mobileIcon)
})
